<template>
  <div id='main' class="touch mw9 center private">

    <header>
      <nav-bar @side-nav-toggle="sideNavVisible = !sideNavVisible" class="h-100 w-100"/>
    </header>

    <aside :class="[sideNavVisible ? 'show-side-nav' : 'hide-side-nav' ]">
      <side-nav @hide="sideNavVisible = false"/>
    </aside>

    <main>
      <component v-if="view" :is="view" v-bind="$attrs"/>
    </main>

    <portal-target name="modals"/>
    <notifications/>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import SideNav from '@/components/SideNav.vue'
import Notifications from '@/components/notifications/Notifications.vue'

export default {
  name: 'cabinet',
  components: {
    NavBar,
    SideNav,
    Notifications
  },
  data: () => ({
    sideNavVisible: false
  }),
  computed: {
    view () {
      return this.$route.meta.component
    }
  }
}
</script>

<style lang="scss" scoped>
.hide-side-nav {
  -webkit-transform: translate3d( -100%, 0, 0 );
  transform: translate3d( -100%, 0, 0 );
  -webkit-transition: transform 0.15s linear;
  transition: transform 0.15s linear;
}
.show-side-nav {
  -webkit-transform: translate3d( 0, 0, 0 );
  transform: translate3d( 0, 0, 0 );
  -webkit-transition: transform transform 0.15s ease-out;
  transition: transform 0.15s ease-out;
}
@media screen and (min-width: 60em) {
  .hide-side-nav, .show-side-nav {
    -webkit-transform: translate3d( 0, 0, 0 );
    transform: translate3d( 0, 0, 0 );
    -webkit-transition: transform 0s linear;
    transition: transform 0s linear;
  }
}
.private {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 60px auto;
  grid-template-areas:
    "header"
    "main"
}
@media screen and (min-width: 60em) {
  .private {
    display: grid;
    grid-template-columns: 250px 1fr;
    grid-template-rows: 60px auto;
    grid-template-areas:
      "sidebar header"
      "sidebar main"
  }
}
header {
  grid-area: header;
}
main {
  grid-area: main;
}
aside {
  grid-area: sidebar;
  position: fixed;
  width: 250px;
  height: 100vh;
  z-index: 600;
}
</style>
